/*
 *   File : nominee.js
 *   Author URI : https://evoqins.com
 *   Description :  Component which the user can add nominees to an existing KYC request.
 *   Integrations : null
 *   Version : v1.1
 */

import { Fragment, useRef, useState, useEffect } from "react";
import { parse, differenceInYears, format } from 'date-fns';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap';
import { useSelector } from "react-redux";
import { NomineeOTPVerification } from "../../../../Components/Modal";
// import { _getKycProfile, _getProfile } from "../../../Helper/api";
import { _getKycProfile, _getProfile } from "../../../../Helper/api";
import { GradientButton } from "../../../../Components/Cta";
import APIService from "../../../../Services/api-service";
import { CustomSearchSelectBox, CustomTextInput, DatePicker, RadioGroup } from "../../../../Components/FormElements";
import { Icon } from "../../../../Components/Icon";
import Store from "../../../../Store";
import { useLocation } from "react-router-dom";

const SOA_DECLARATIONS = [{
    id: 1,
    label: "Show all nominee names"
},
{
    id: 2,
    label: "Show nominee status"
}]

const NOMINEE = {
    name: "",
    allocation: "",
    date_of_birth: null,
    relation: null,
    is_minor: false,
    guardian_name: "",
    guardian_relationship: null,
    guardian_pan: "",
    guardian_pan: "",
    proof: null,
    proof_number: "",
    nominee_email: "",
    nominee_mobile: "",
    nominee_address_line1: "",
    nominee_address_line2: "",
    nominee_address_line3: "",
    country: { label: "India", value: 101 },
    state: null,
    city: null,
    pincode: "",
    email_declaration: null,
    mobile_declaration: null,
    soa_declaration: SOA_DECLARATIONS[0].id

};

const NOMINEE_ERROR = {
    name: "",
    allocation: "",
    date_of_birth: "",
    relation: "",
    guardian_name: "",
    guardian_pan: "",
    guardian_relationship: "",
    proof: "",
    proof_number: "",
    nominee_email: "",
    nominee_mobile: "",
    nominee_address_line1: "",
    nominee_address_line2: "",
    nominee_address_line3: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    email_declaration: "",
    mobile_declaration: "",
}


const NriNomineePage = (props) => {

    const { state } = useLocation();
    const NOMINEE_DATA = useSelector(state => state.MT_ADMIN_STORE.KYC_DATA);
    console.log('NOMINEE_DATA', NOMINEE_DATA);

    const GENERAL_DATA = useSelector(state => state.MT_ADMIN_STORE.GENERAL_FILTERS);
    console.log('GENERAL_DATA_NOMINEE', GENERAL_DATA);

    const nomineeErrorRef = useRef([]);
    const [optInNominee, setOptInNominee] = useState(false);
    console.log('optInNominee', optInNominee);

    const [nomineeDetail, setNomineeDetail] = useState([]);
    console.log('nomineeDetail', nomineeDetail);

    const [forceUpdate, setForceUpdate] = useState(false);
    const [totalAllocationError, setTotalAllocationError] = useState("");
    const [guardianOptions, setGuardianOptions] = useState([]);
    const [relationOptions, setRelationOptions] = useState([]);
    const [apiLoader, setApiLoader] = useState(false);
    const [showPinModal, setShowPinModal] = useState(false);
    const [processedNomineeData, setProcessedNomineeData] = useState([]);
    const [deleteHover, setDeleteHover] = useState(-1);

    const [countryOption, setCountryOptions] = useState([]);
    const [identityProofOptions, setIdentityProofOptions] = useState([])
    const [declarationOptions, setDeclarationOptions] = useState([])
    const [isMinor, setIsMinor] = useState(false);

    // max date that can be selected for dob (current date - 18 years)
    const maxDate = new Date();
    // maxDate.setFullYear(maxDate.getFullYear() - 18);

    useEffect(() => {
        _getCountries();
    }, []);

    useEffect(() => {
        const proofs = GENERAL_DATA.nominee_id_proof.map((item) => ({
            label: item.name,
            value: item.id
        }))
        setIdentityProofOptions(proofs)
        const signup_relation = GENERAL_DATA.signup_relation.map((item) => ({
            label: item.name,
            value: item.id
        }))
        setDeclarationOptions(signup_relation)
    }, [GENERAL_DATA])

    useEffect(() => {
        if (NOMINEE_DATA.nominees.length === 0) {
            setNomineeDetail([NOMINEE]);
            nomineeErrorRef.current = [NOMINEE_ERROR];
        }
        else {
            const nominee_data = NOMINEE_DATA.nominees.map(({ name,
                allocation,
                date_of_birth,
                relationship_id,
                relationship,
                guardian_name,
                guardian_pan,
                guardian_relationship_id,
                guardian_relationship,
                ...rest }, index) => {
                // Parse the date_of_birth and format it as 'dd-MM-yyyy'

                let formatted_date = date_of_birth;
                if (date_of_birth) {
                    formatted_date = format(parse(date_of_birth, 'dd-MM-yyyy', new Date()), 'dd/MM/yyyy');
                }

                return {
                    ...rest,
                    name: name,
                    allocation: allocation,
                    date_of_birth: formatted_date,
                    relation: {
                        value: relationship_id,
                        label: relationship
                    },
                    is_minor: _is18YearsOld(formatted_date),
                    guardian_name: guardian_name,
                    guardian_pan: guardian_pan,
                    guardian_relationship: {
                        value: guardian_relationship_id,
                        label: guardian_relationship
                    },
                    proof: rest.nominee_proof_type_id !== null ? {
                        value: rest.nominee_proof_type_id,
                        label: rest.nominee_proof_type
                    } : null,
                    proof_number: rest.nominee_proof_id !== null ? rest.nominee_proof_id : "",
                    nominee_mobile: rest.nominee_mobile !== null ? rest.nominee_mobile : "",
                    nominee_email: rest.nominee_email !== null ? rest.nominee_email : "",
                    nominee_address_line1: rest.nominee_address_line1 !== null ? rest.nominee_address_line1 : "",
                    nominee_address_line2: rest.nominee_address_line2 !== null ? rest.nominee_address_line2 : "",
                    nominee_address_line3: rest.nominee_address_line3 !== null ? rest.nominee_address_line3 : "",
                    country: rest.nominee_country_id !== null ? {
                        value: rest.nominee_country_id,
                        label: rest.nominee_country
                    } : { label: "India", value: 101 },

                    state: rest.nominee_state_id !== null && rest.nominee_country_id === 101 ? {
                        value: rest.nominee_state_id,
                        label: rest.nominee_state
                    } : rest.nominee_state_name !== null ? rest.nominee_state_name : null,
                    city: rest.nominee_city_id !== null && rest.nominee_country_id === 101 ? {
                        value: rest.nominee_city_id,
                        label: rest.nominee_city
                    } : rest.nominee_city_name !== null ? rest.nominee_city_name : null,
                    pincode: rest.nominee_pincode !== null ? rest.nominee_pincode : "",
                    email_declaration: rest.nominee_email_declaration_id !== null ? {
                        value: rest.nominee_email_declaration_id,
                        label: rest.nominee_email_declaration
                    } : null,
                    mobile_declaration: rest.nominee_mobile_declaration !== null ? {
                        value: rest.nominee_mobile_declaration_id,
                        label: rest.nominee_mobile_declaration
                    } : null,
                    states: rest.nominee_state_id !== null ? _getStates({
                        value: rest.nominee_country_id,
                        label: rest.nominee_country
                    }, index) : _getStates({ label: "India", value: 101 }, index),
                    cities: rest.nominee_state_id !== null ? _getCities({
                        value: rest.nominee_state_id,
                        label: rest.nominee_state
                    }, index) : [],
                    soa_declaration: SOA_DECLARATIONS[0].id

                };
            });
            for (let i = 0; i < NOMINEE_DATA.nominees.length; i++) {
                nomineeErrorRef.current.push(NOMINEE_ERROR);
            }
            setNomineeDetail(nominee_data)
        }
        if (NOMINEE_DATA.skip_nominee === true || NOMINEE_DATA.skip_nominee === null) {
            setOptInNominee(false);
        }
        else {
            setOptInNominee(true);
        }


        // Get general data (to get relation and guardian options)
        let relation_data = GENERAL_DATA.nominee_relation?.map((item) => {
            return ({ value: item.id, label: item.name })
        });
        let guardian_data = GENERAL_DATA.nominee_guardian_relation.map((item) => {
            return ({ value: item.id, label: item.name })
        });
        setGuardianOptions(guardian_data);
        setRelationOptions(relation_data);
    }, [NOMINEE_DATA, GENERAL_DATA])

    useEffect(() => {
        if (showPinModal === true) {
            const modal = new Modal(document.getElementById("nominee-otp"), {});
            modal.show();
        }
    }, [showPinModal])

    const _handleRadioInput = () => {
        setOptInNominee(!optInNominee);
    }

    // API - get countries
    const _getCountries = () => {
        const url = "general/countries";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                const countries = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.country_id
                    })
                })
                if (NOMINEE_DATA.nominees.length === 0) {
                    _getStates({ label: "India", value: 101 }, 0)
                }
                setCountryOptions(countries);
            }
        })
    }

    // API - get countries
    const _getStates = (e, index) => {
        const url = "general/states";

        setNomineeDetail((prev) => {
            const nominee = [...prev];

            // Prevent potential crash on undefined index
            // if (!nominee[index]) return prev;

            nominee[index] = {
                ...nominee[index],
                country: e,
                state: null,
                city: null,
                states: [], // clear previous states immediately
            };

            APIService(true, url, { country_id: Number(e.value) }).then((response) => {
                if (response.status_code === 200) {
                    const states = response.data.map((item) => ({
                        label: item.name,
                        value: item.state_id
                    }));

                    // Update states again after async call
                    setNomineeDetail((prevNominee) => {
                        const updated = [...prevNominee];
                        if (!updated[index]) return prevNominee;

                        updated[index] = {
                            ...updated[index],
                            states: states
                        };
                        nomineeErrorRef.current[index].country = "";
                        console.log(updated)
                        return updated;
                    });
                } else {
                    setNomineeDetail((prevNominee) => {
                        const updated = [...prevNominee];
                        // if (!updated[index]) return prevNominee;

                        updated[index] = {
                            ...updated[index],
                            states: []
                        };
                        return updated;
                    });
                }
            });

            return nominee;
        });
    };


    // API - get cities
    const _getCities = (e, index) => {

        const url = "general/cities";

        setNomineeDetail((prev) => {
            const nominee = [...prev];

            // Prevent potential crash on undefined index
            // if (!nominee[index]) return prev;

            nominee[index] = {
                ...nominee[index],
                state: e,
                city: null,
                cities: [], // clear previous states immediately
            };

            APIService(true, url, { state_id: Number(e.value) }).then((response) => {
                if (response.status_code === 200) {
                    const cities = response.data.map((item) => ({
                        label: item.name,
                        value: item.state_id
                    }));

                    // Update states again after async call
                    setNomineeDetail((prevNominee) => {
                        const updated = [...prevNominee];
                        if (!updated[index]) return prevNominee;

                        updated[index] = {
                            ...updated[index],
                            cities: cities
                        };
                        nomineeErrorRef.current[index].state = "";
                        return updated;
                    });
                }
            });

            return nominee;
        });
    }

    const _handleInput = (type, value, key, is_text = false) => {
        let nominee = [...nomineeDetail];

        console.log('value_change', value);


        switch (type) {
            case 1:
                // Create a new copy of the array
                nominee[key] = { ...nominee[key], name: value }; // Update the specific element
                nomineeErrorRef.current[key].name = "";
                setNomineeDetail(nominee);
                break;
            case 2:
                console.log("date", value)
                nominee[key] = { ...nominee[key], date_of_birth: value, is_minor: _is18YearsOld(value) }; // Update the specific element
                if (_is18YearsOld(value) === true) {
                    nominee[key] = { ...nominee[key], guardian_name: "" }
                    nominee[key] = { ...nominee[key], guardian_relationship: null }
                    nominee[key] = { ...nominee[key], guardian_pan: "" }
                    nomineeErrorRef.current[key].guardian_name = "";
                    nomineeErrorRef.current[key].guardian_relationship = "";
                    nomineeErrorRef.current[key].guardian_pan = "";
                }
                nomineeErrorRef.current[key].date_of_birth = "";
                setNomineeDetail(nominee);
                break;
            case 3:
                nominee[key] = { ...nominee[key], relation: value }; // Update the specific element
                nomineeErrorRef.current[key].relation = "";
                setNomineeDetail(nominee);
                break;
            case 4:
                nominee[key] = { ...nominee[key], allocation: value }; // Update the specific element
                nomineeErrorRef.current[key].allocation = "";
                setTotalAllocationError("");
                setNomineeDetail(nominee);
                break;
            case 5:
                nominee[key] = { ...nominee[key], guardian_name: value };
                nomineeErrorRef.current[key].guardian_name = "";
                setNomineeDetail(nominee);
                break;
            case 6:
                nominee[key] = { ...nominee[key], guardian_relationship: value };
                nomineeErrorRef.current[key].guardian_relationship = "";
                setNomineeDetail(nominee);
                break;
            case 7:
                nominee[key] = { ...nominee[key], guardian_pan: value };
                nomineeErrorRef.current[key].guardian_pan = "";
                setNomineeDetail(nominee);
                break;
            case 8:
                nominee[key] = { ...nominee[key], proof: value, proof_number: "" }; // Update the specific element
                nomineeErrorRef.current[key].proof = "";
                setNomineeDetail(nominee);
                break;
            case 9:
                nominee[key] = { ...nominee[key], proof_number: value }; // Update the specific element
                nomineeErrorRef.current[key].proof_number = "";
                setNomineeDetail(nominee);
                break;
            case 10:
                nominee[key] = { ...nominee[key], nominee_email: value }; // Update the specific element
                nomineeErrorRef.current[key].nominee_email = "";
                setNomineeDetail(nominee);
                break;
            case 11:
                nominee[key] = { ...nominee[key], nominee_mobile: value }; // Update the specific element
                nomineeErrorRef.current[key].nominee_mobile = "";
                setNomineeDetail(nominee);
                break;
            case 12:
                nominee[key] = { ...nominee[key], nominee_address_line1: value }; // Update the specific element
                nomineeErrorRef.current[key].nominee_address_line1 = "";
                setNomineeDetail(nominee);
                break;
            case 13:
                nominee[key] = { ...nominee[key], nominee_address_line2: value }; // Update the specific element
                nomineeErrorRef.current[key].nominee_address_line2 = "";
                setNomineeDetail(nominee);
                break;
            case 14:
                nominee[key] = { ...nominee[key], nominee_address_line3: value }; // Update the specific element
                nomineeErrorRef.current[key].nominee_address_line3 = "";
                setNomineeDetail(nominee);
                break;
            // case 15:
            //     _getStates(value, key)
            //     break;
            case 15:
                if (value.value === 101) {
                    _getStates(value, key)
                } else {
                    // For non-India countries, just update country and clear state/city
                    let nominee = [...nomineeDetail];
                    nominee[key] = {
                        ...nominee[key],
                        country: value,
                        state: null,
                        city: null,
                        states: [],
                        cities: [],
                    };
                    nomineeErrorRef.current[key].country = "";
                    setNomineeDetail(nominee);
                }
                break;
            case 16:
                // nominee[key] = { ...nominee[key], city: value }; // Update the specific element
                // nomineeErrorRef.current[key].city = "";
                if (is_text === true) {
                    nominee[key] = { ...nominee[key], state: value }; // Update the specific element
                    nomineeErrorRef.current[key].state = "";
                    setNomineeDetail(nominee);
                } else {
                    _getCities(value, key)
                }
                // setNomineeDetail(nominee);
                break;
            case 17:
                nominee[key] = { ...nominee[key], city: value }; // Update the specific element
                nomineeErrorRef.current[key].city = "";
                setNomineeDetail(nominee);
                break;
            case 18:
                nominee[key] = { ...nominee[key], pincode: value }; // Update the specific element
                nomineeErrorRef.current[key].pincode = "";
                setNomineeDetail(nominee);
                break;
            case 19:
                nominee[key] = { ...nominee[key], email_declaration: value }; // Update the specific element
                nomineeErrorRef.current[key].email_declaration = "";
                setNomineeDetail(nominee);
                break;
            case 20:
                nominee[key] = { ...nominee[key], mobile_declaration: value }; // Update the specific element
                nomineeErrorRef.current[key].mobile_declaration = "";
                setNomineeDetail(nominee);
                break;
            case 21:
                nominee[key] = { ...nominee[key], soa_declaration: value }; // Update the specific element
                nomineeErrorRef.current[key].soa_declaration = "";
                setNomineeDetail(nominee);
                break;
        }
    }

    const _is18YearsOld = (dobString) => {
        // Parse the date of birth string into a Date object
        const dob = parse(dobString, 'dd/MM/yyyy', new Date());

        // Calculate the age difference
        const age_difference = differenceInYears(new Date(), dob);
        return age_difference >= 18 ? false : true;
    }


    const _scrollToErrorElement = (id) => {
        const element = document.getElementById(id);
        if (!element) return;
        element.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest"
        });
    }

    const _validateMinor = (type) => {
        let valid = true;
        let nominee = [...nomineeDetail];
        console.log('nominee', nominee)
        nominee.forEach((item, key) => {
            console.log('key', key);
            if (item.name.length === 0) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], name: "Please provide name" };
                _scrollToErrorElement(`name-${key}`);
                valid = false;
            }

            // DOB is mandatory only when the nominee is a minor (SEBI modified nomination norms)
            if (item.is_minor === true && (item.date_of_birth === null || item.date_of_birth === "")) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], date_of_birth: "Please provide date of birth" };
                _scrollToErrorElement(`dob-${key}`);
                valid = false;
            }

            if (item.relation === null) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], relation: "Please provide relation" };
                _scrollToErrorElement(`relation-${key}`);
                valid = false;
            }

        });

        if (valid === true) {
            if (type === 1) {
                // allocation is optional — only enforce the 100% rule once every nominee has one
                const allocations_provided = nominee.every(n => n.allocation !== "" && n.allocation !== null && n.allocation !== undefined);
                const total_allocation = nominee.reduce((acc, curr) => acc + (parseInt(curr.allocation) || 0), 0);
                if (allocations_provided && total_allocation !== 100) {
                    valid = false;
                    setTotalAllocationError("The total allocation must equal 100%");
                }
                else {
                    setIsMinor(true)
                    // props.updateProgress(8);
                }
            }
            else {
                _handleMore();
            }
        }
        setForceUpdate(!forceUpdate);
    }

    const _validateForm = (type) => {
        let valid = true;
        let nominee = [...nomineeDetail];
        console.log('nominee', nominee)
        nominee.forEach((item, key) => {
            console.log('key', key);
            if (item.name.length === 0) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], name: "Please provide name" };
                _scrollToErrorElement(`name-${key}`);
                valid = false;
            }

            // DOB is mandatory only when the nominee is a minor (SEBI modified nomination norms)
            if (item.is_minor === true && (item.date_of_birth === null || item.date_of_birth === "")) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], date_of_birth: "Please provide date of birth" };
                _scrollToErrorElement(`dob-${key}`);
                valid = false;
            }

            if (item.relation === null) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], relation: "Please provide relation" };
                _scrollToErrorElement(`relation-${key}`);
                valid = false;
            }

            // guardian PAN — format checked only when provided (guardian details are optional per SEBI norms)
            if (item.guardian_pan && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(item.guardian_pan.toLocaleUpperCase())) {
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], guardian_pan: "Please provide valid PAN number" };
                _scrollToErrorElement(`g-pan-${key}`);
                valid = false;
            }

            // identity proof number — PAN format checked only when the proof type is PAN and a value is provided
            if (item.proof !== null && item.proof.label == "Pan" && item.proof_number !== "" && (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(item.proof_number.toLocaleUpperCase()))) {
                _scrollToErrorElement(`proof_number-${key}`);
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], proof_number: "Invalid PAN" };
                valid = false;
            }

            if (item.nominee_email !== "" && (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(item.nominee_email))) {
                _scrollToErrorElement(`nominee_email-${key}`);
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], nominee_email: "Invalid email" };
                valid = false;
            }

            if (item.nominee_mobile !== "" && item.nominee_mobile.length !== 10) {
                _scrollToErrorElement(`nominee_mobile-${key}`);
                nomineeErrorRef.current[key] = { ...nomineeErrorRef.current[key], nominee_mobile: "Invalid mobile number" };
                valid = false;
            }


        });

        if (valid === true) {
            if (type === 1) {
                // allocation is optional — only enforce the 100% rule once every nominee has one
                const allocations_provided = nominee.every(n => n.allocation !== "" && n.allocation !== null && n.allocation !== undefined);
                const total_allocation = nominee.reduce((acc, curr) => acc + (parseInt(curr.allocation) || 0), 0);
                if (allocations_provided && total_allocation !== 100) {
                    valid = false;
                    setTotalAllocationError("The total allocation must equal 100%");
                }
                else {
                    let proceed_nominees = _processNomineeData();
                    console.log("Processed nominee", proceed_nominees)
                    _validateNominee(proceed_nominees);
                    setProcessedNomineeData(proceed_nominees);
                    // props.updateProgress(8);
                }
            }
            else {
                _handleMore();
            }
        }
        setForceUpdate(!forceUpdate);
    }

    function _processNomineeData() {
        const updated_data = nomineeDetail.map(({ name, relation, guardian_name, guardian_relationship, is_minor, date_of_birth, ageCheck, date_of_birth_str, guardian_pan, proof, proof_number, nominee_email, nominee_mobile, nominee_address_line1, nominee_address_line2, nominee_address_line3, country, state, city, pincode, email_declaration, mobile_declaration, soa_declaration, ...rest }) => {
            console.log("Minor", is_minor)
            // Parse the date_of_birth and format it as 'dd-MM-yyyy' — only when provided (DOB is optional for adult nominees)
            const formatted_date = date_of_birth ? format(parse(date_of_birth, 'dd/MM/yyyy', new Date()), 'dd-MM-yyyy') : null;

            return {
                // ...rest,
                name: name,
                allocation: rest.allocation,
                relation_id: relation.value,
                guardian_name: is_minor === false ? null : guardian_name,
                guardian_pan: is_minor === false ? null : guardian_pan,
                guardian_relationship_id: (is_minor === false || !guardian_relationship) ? null : guardian_relationship.value,
                date_of_birth: formatted_date,
                nominee_proof_type_id: proof !== null ? proof.value : null,
                nominee_proof_id: proof_number,
                nominee_email: nominee_email,
                nominee_mobile: nominee_mobile,
                nominee_address_line1: nominee_address_line1,
                nominee_address_line2: nominee_address_line2,
                nominee_address_line3: nominee_address_line3,
                nominee_state_id: state !== null ? state.value : null,
                nominee_city_id: city !== null ? city.value : null,
                nominee_state_name: state !== null && country?.value !== 101 ? state : null,
                nominee_city_name: city !== null && country?.value !== 101 ? city : null,
                nominee_country_id: country !== null ? country.value : null,
                nominee_pincode: pincode,
                nominee_mobile_declaration_id: mobile_declaration !== null ? mobile_declaration.value : null,
                nominee_email_declaration_id: email_declaration !== null ? email_declaration.value : null,
                soa_declaration: soa_declaration === 1 ? true : false
            };
        });
        return updated_data;
    }

    const _handleMore = () => {
        let nominee = [...nomineeDetail]
        nominee.push(NOMINEE)
        setTotalAllocationError("");
        nomineeErrorRef.current.push(NOMINEE_ERROR);
        setNomineeDetail(nominee);
        _getStates({ label: "India", value: 101 }, nominee.length - 1)
    }

    function _removeNominee(key) {
        let nominee_detail = [...nomineeDetail];
        nominee_detail.splice(key, 1);
        let errorRef = [...nomineeErrorRef.current];
        setNomineeDetail(nominee_detail);
        nomineeErrorRef.current = errorRef;
    }

    // update the UI to next step after success of add nominee
    async function _handleSuccess() {
        props.updateProgress(NOMINEE_DATA.onboarding_type === "NRI" ? NOMINEE_DATA.is_review ? 10 : 9 : NOMINEE_DATA.is_review ? 9 : 8);
    }

    // API - validate nominee
    function _validateNominee(nomineeData) {
        setApiLoader(true);
        let url = 'kyc/nominee/confirm';
        let payload = JSON.stringify({
            customer_id: state.user_id,
            is_nominee_available: optInNominee,
            is_review: props.edit,
            nominee: optInNominee === true ? nomineeData : [],
        });

        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {

                toast.dismiss();
                if (response.otp_verification_needed === false) {
                    props.updateProgress(NOMINEE_DATA.onboarding_type === "NRI" ? NOMINEE_DATA.is_review ? 10 : 9 : NOMINEE_DATA.is_review ? 9 : 8);
                    toast.success("Nominee details updated successfully", {
                        type: "success",
                    });
                } else {
                    toast.success("OTP sent successfully", {
                        type: "success",
                    });
                    setShowPinModal(true);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
            }
            setApiLoader(false);
        });

    }

    // API :: add nominee
    async function _submitNominee(otp) {
        setApiLoader(true);
        let status = true;
        let url = 'kyc/add-nominee';
        let payload = JSON.stringify({
            customer_id: state.user_id,
            is_nominee_available: optInNominee,
            otp,
            is_review: props.edit,
            nominee: optInNominee === true ? processedNomineeData : [],
        });
        await APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                Store.dispatch({
                    type: 'GET_KYC_DATA',
                    payload: response.kyc_data
                });
                // _getProfile();
                if (optInNominee === true) {
                    toast.success('Nominee details updated successfully', {
                        type: 'success'
                    });
                } else {
                    toast.success('Nominee opted out successfully', {
                        type: 'success'
                    });
                }

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
                status = false;
            }
            setApiLoader(false);
        });
        return status;
    }

    return (
        <div className="row pb-sm-0 pb-3">
            <div className="col-lg-7 col-md-7 col-12 pe-lg-5 pe-md-5 pe-1">
                <p className="color-black e-poppins e-poppins-bold e-font-24 mb-2">Add nominee</p>
                <p className="color-outer-space e-poppins-regular e-font-16 e-font-sm-16-14 line-height-24px mb-0">
                    You can add up to 3 nominees to your account. You can add them now or later in the profile section.
                </p>
                <div className="margin-32px-top d-lg-flex d-md-flex d-block gap-40px">
                    <div className="d-flex align-items-center gap-8px cursor-pointer"
                        onClick={_handleRadioInput}>
                        <Icon icon={optInNominee === false ? "radio-unselected" : "radio-selected"}
                            size={20} />
                        <p className="color-outer-space e-poppins-regular e-font-16 e-font-sm-16-14 line-height-24px mb-0">I want to opt for nominee</p>
                    </div>
                    <div className="d-flex align-items-center gap-8px cursor-pointer mt-lg-0 mt-md-0 mt-3"
                        onClick={_handleRadioInput}>
                        <Icon icon={optInNominee === false ? "radio-selected" : "radio-unselected"}
                            size={20} />
                        <p className="color-outer-space e-poppins-regular e-font-16 e-font-sm-16-14 line-height-24px mb-0">I want to opt out for nominee</p>
                    </div>

                </div>
                {
                    optInNominee === false &&
                    <GradientButton label="Opt out & proceed"
                        className="padding-12px-tb px-4 e-font-16 margin-64px-top"
                        onPress={_validateNominee} />
                }

                {
                    optInNominee === true &&
                    <Fragment>
                        {
                            nomineeDetail.map((item, key) => {
                                return (
                                    <div className="margin-34px-top pe-lg-5 pe-md-5 pe-0 me-lg-4 me-md-4 me-0 row position-relative"
                                        key={key}>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <p className="color-black e-font-16 e-font-sm-16-14 e-poppins-semi-bold mb-0">Nominee {key + 1}</p>
                                            {
                                                key !== 0 && (
                                                    <Icon icon={deleteHover === key ? "delete-red" : "delete"}
                                                        size={24}
                                                        className="cursor-pointer"
                                                        onMouseEnter={() => setDeleteHover(key)}
                                                        onMouseLeave={() => setDeleteHover(-1)}
                                                        onClick={() => _removeNominee(key)} />
                                                )
                                            }
                                        </div>

                                        {isMinor === false && <Fragment>
                                            <div className="col-12" id={`name-${key}`}>
                                                <CustomTextInput label="Name"
                                                    onEnter={_validateForm}
                                                    postfix="*"
                                                    id={`name-input-${key}`}
                                                    value={item.name}
                                                    className="margin-32px-bottom"
                                                    error={nomineeErrorRef.current[key]['name']}
                                                    valueChange={(data) => _handleInput(1, data, key)} />
                                            </div>
                                            <div className="col-12" id={`relation-${key}`}>
                                                <CustomSearchSelectBox value={item.relation}
                                                    label="Relation"
                                                    error={nomineeErrorRef.current[key]['relation']}
                                                    postfix="*"
                                                    className="margin-32px-bottom "
                                                    options={relationOptions}
                                                    onSelectChange={(value) => _handleInput(3, value, key)} />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12" id={`dob-${key}`}>
                                                <DatePicker label="Date of Birth"
                                                    error={nomineeErrorRef.current[key]['date_of_birth']}
                                                    value={item.date_of_birth}
                                                    isAdult={true}
                                                    maxDate={maxDate}
                                                    dob={(value) => _handleInput(2, value, key)} />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12 mt-4 pt-2" id={`allocation-${key}`}>
                                                <CustomTextInput label="Allocation percentage"
                                                    type="number"
                                                    max={3}
                                                    maxValue={100}
                                                    onEnter={_validateForm}
                                                    id={`allocation-input-${key}`}
                                                    value={item.allocation}
                                                    className="margin-32px-bottom "
                                                    error={nomineeErrorRef.current[key]['allocation']}
                                                    valueChange={(value) => _handleInput(4, value, key)} />
                                            </div>
                                        </Fragment>}
                                        {
                                            item.is_minor === true &&
                                            <Fragment>
                                                <div className="col-12">
                                                    <div className="d-flex gap-1 align-items-start border-radius-16px bg-beige w-fit-content p-3 mb-4">
                                                        <span>
                                                            <Icon icon="info"
                                                                size={16} />
                                                        </span>
                                                        <p className="color-outer-space e-poppins-regular e-font-14 line-height-24px pt-1 mb-0">
                                                            As the nominee is identified as a minor based on the date of birth provided, it is mandatory to add the details of a legal guardian.
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="color-black e-font-16 e-font-sm-16-14 e-poppins-medium mb-4">Guardian Details</p>

                                                <div className="col-12" id={`g-name-${key}`}>
                                                    <CustomTextInput label="Guardian name"
                                                        id={`g-name-input-${key}`}
                                                        value={item.guardian_name}
                                                        className="margin-32px-bottom"
                                                        error={nomineeErrorRef.current[key]['guardian_name']}
                                                        valueChange={(data) => _handleInput(5, data, key)} />
                                                </div>
                                                <div className="col-12" id={`g-relation-${key}`}>
                                                    <CustomSearchSelectBox value={item.guardian_relationship}
                                                        label="Guardian relation"
                                                        error={nomineeErrorRef.current[key]['guardian_relationship']}
                                                        className="margin-32px-bottom "
                                                        options={guardianOptions}
                                                        onSelectChange={(value) => _handleInput(6, value, key)} />
                                                </div>
                                                <div className="col-12" id={`g-pan-${key}`}>
                                                    <CustomTextInput label="Guardian PAN number"
                                                        pan={true}
                                                        id={`g-pan-input-${key}`}
                                                        inputClass="text-uppercase"
                                                        value={item.guardian_pan}
                                                        className="margin-32px-bottom"
                                                        error={nomineeErrorRef.current[key]['guardian_pan']}
                                                        valueChange={(data) => _handleInput(7, data, key)} />
                                                </div>

                                            </Fragment>

                                        }

                                        <div className="col-lg-12 col-md-12 col-12 mt-lg-0 mt-md-0 mt-4" id={`proof-${key}`}>
                                            <CustomSearchSelectBox value={item.proof}
                                                label="Select Identity document"
                                                error={nomineeErrorRef.current[key]['proof']}
                                                className="margin-32px-bottom "
                                                options={identityProofOptions}
                                                onSelectChange={(value) => _handleInput(8, value, key)} />
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12 mt-lg-0 mt-md-0 mt-4" id={`proof_number-${key}`}>
                                            <CustomTextInput label={`${item.proof !== null ? item.proof.label == "Aadhaar" ? "Las 4 digits of Aadhaar" : item.proof.label : "Idenitity"} number`}
                                                id={`proof_number_input-${key}`}
                                                value={item.proof_number}
                                                onEnter={_validateForm}
                                                className="margin-32px-bottom "
                                                type={item.proof !== null && item.proof.label == "Aadhaar" ? "number" : "text"}
                                                max={item.proof !== null ? item.proof.label == "Passport" ? 9 : item.proof.label === "Aadhaar" ? 4 : item.proof.label == "Driving license" ? 20 : 10 : undefined}
                                                error={nomineeErrorRef.current[key]['proof_number']}
                                                inputClass={item.proof !== null && item.proof.label == "Pan" ? "text-uppercase" : ""}
                                                valueChange={(value) => _handleInput(9, value, key)} />
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12 mt-lg-0 mt-md-0 mt-4" id={`nominee_mobile-${key}`}>
                                            <CustomTextInput label="Phone number"
                                                type="number"
                                                max={10}
                                                onEnter={_validateForm}
                                                value={item.nominee_mobile}
                                                className="margin-32px-bottom "
                                                id={`nominee_mobile_inpur-${key}`}
                                                error={nomineeErrorRef.current[key]['nominee_mobile']}
                                                valueChange={(value) => _handleInput(11, value, key)} />
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12 mt-lg-0 mt-md-0 mt-4" id={`nominee_email-${key}`}>
                                            <CustomTextInput label="Email"
                                                type="email"
                                                value={item.nominee_email}
                                                id={`nominee_email_input-${key}`}
                                                className="margin-32px-bottom "
                                                error={nomineeErrorRef.current[key]['nominee_email']}
                                                valueChange={(value) => _handleInput(10, value, key)} />
                                        </div>
                                        <div className="col-12 pb-3">
                                            <div className="d-flex gap-1 bg-beige border-radius-8px p-3">
                                                <span>
                                                    <Icon icon="info"
                                                        size={20} />
                                                </span>
                                                <p className="e-font-14 e-poppins-regular line-height-24px color-jett-black mb-0 ">
                                                    Each Address Line can be up to 40 characters long, with hyphen (-) and oblique (/) allowed as special characters.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`address1-${key}`}>
                                            <CustomTextInput label="Address Line 1"
                                                type="text"
                                                value={item.nominee_address_line1}
                                                className="margin-32px-bottom "
                                                max={40}
                                                onEnter={_validateForm}
                                                is_address
                                                id={`address1_input-${key}`}
                                                error={nomineeErrorRef.current[key]['nominee_address_line1']}
                                                valueChange={(value) => _handleInput(12, value, key)} />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`address2-${key}`}>
                                            <CustomTextInput label="Address Line 2"
                                                type="text"
                                                value={item.nominee_address_line2}
                                                id={`address2_input-${key}`}
                                                onEnter={_validateForm}
                                                max={40}
                                                is_address
                                                className="margin-32px-bottom "
                                                error={nomineeErrorRef.current[key]['nominee_address_line2']}
                                                valueChange={(value) => _handleInput(13, value, key)} />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`address3-${key}`}>
                                            <CustomTextInput label="Address Line 3"
                                                type="text"
                                                value={item.nominee_address_line3}
                                                className="margin-32px-bottom "
                                                onEnter={_validateForm}
                                                id={`address3_input-${key}`}
                                                max={40}
                                                is_address
                                                error={nomineeErrorRef.current[key]['nominee_address_line3']}
                                                valueChange={(value) => _handleInput(14, value, key)} />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`country-${key}`}>
                                            <CustomSearchSelectBox value={item.country}
                                                label="Country"
                                                isSearchable={true}
                                                className="margin-32px-bottom"
                                                error={nomineeErrorRef.current[key]['country']}
                                                options={countryOption}
                                                onSelectChange={(e) => {
                                                    _handleInput(15, e, key);
                                                }} />
                                        </div>
                                        {



                                            item.states?.length > 0 ?
                                                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`state-${key}`}>
                                                    <CustomSearchSelectBox value={item.state}
                                                        label="State"
                                                        isSearchable={true}
                                                        className="margin-32px-bottom"
                                                        isDisabled={item.country === null ? true : false}
                                                        error={nomineeErrorRef.current[key]['state']}
                                                        options={item.states || []}
                                                        onSelectChange={(e) => {
                                                            _handleInput(16, e, key, false);

                                                        }} />
                                                </div>
                                                :
                                                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`state-${key}`}>
                                                    <CustomTextInput label="State"
                                                        type="text"
                                                        onEnter={_validateForm}
                                                        value={item.state}
                                                        className="margin-32px-bottom "
                                                        id={`state_text_input-${key}`}
                                                        error={nomineeErrorRef.current[key]['state']}
                                                        valueChange={(value) => _handleInput(16, value, key, true)} />
                                                </div>
                                        }
                                        {
                                            item.states?.length > 0 ?
                                                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`city-${key}`}>
                                                    <CustomSearchSelectBox value={item.city}
                                                        label="City"
                                                        isSearchable={true}
                                                        className="margin-32px-bottom"
                                                        error={nomineeErrorRef.current[key]['city']}
                                                        isDisabled={item.state === null ? true : false}
                                                        options={item.cities || []}
                                                        onSelectChange={(e) => {
                                                            _handleInput(17, e, key);
                                                        }} />
                                                </div>
                                                :
                                                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`city-${key}`}>
                                                    <CustomTextInput label="City"
                                                        type="text"
                                                        onEnter={_validateForm}
                                                        value={item.city}
                                                        className="margin-32px-bottom "
                                                        id={`city_text_input-${key}`}
                                                        error={nomineeErrorRef.current[key]['city']}
                                                        valueChange={(value) => _handleInput(17, value, key)} />
                                                </div>
                                        }
                                        <div className="col-lg-12 col-md-12 col-12 mt-lg-0 mt-md-0 mt-4" id={`pincode-${key}`}>
                                            <CustomTextInput label="Pincode"
                                                type="number"
                                                max={6}
                                                onEnter={_validateForm}
                                                value={item.pincode}
                                                id={`pin_input-${key}`}
                                                className="margin-32px-bottom "
                                                error={nomineeErrorRef.current[key]['pincode']}
                                                valueChange={(value) => _handleInput(18, value, key)} />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`email_declaration-${key}`}>
                                            <CustomSearchSelectBox value={item.email_declaration}
                                                label="Email declaration"
                                                isSearchable={true}
                                                className="margin-32px-bottom"
                                                error={nomineeErrorRef.current[key]['email_declaration']}
                                                options={declarationOptions}
                                                onSelectChange={(e) => {
                                                    _handleInput(19, e, key);
                                                }} />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-4" id={`mobile_declaration-${key}`}>
                                            <CustomSearchSelectBox value={item.mobile_declaration}
                                                label="Mobile declaration"
                                                isSearchable={true}
                                                className="margin-32px-bottom"
                                                error={nomineeErrorRef.current[key]['mobile_declaration']}
                                                options={declarationOptions}
                                                onSelectChange={(e) => {
                                                    _handleInput(20, e, key);
                                                }} />
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12 mt-lg-0 mt-md-0 mt-4">
                                            <p className="color-black e-poppins-medium e-font-14 mb-1">Nominee Visibility on account statement</p>
                                            <RadioGroup data={SOA_DECLARATIONS}
                                                className={`gap-16px `}
                                                wrapperClass={"w-max-content"}
                                                spanClass="e-poppins-regular"
                                                iconClassName="me-2"
                                                size={20}
                                                type={1}
                                                id={item.soa_declaration}
                                                radioHandler={(value) => _handleInput(21, value, key)} />
                                        </div>
                                    </div>
                                )
                            })
                        }

                        <div className="d-lg-flex d-md-flex d-block align-items-center justify-content-between margin-40px-lg-top position-relative pe-lg-5 pe-md-5 pe-1 me-lg-4 me-md-4 me-0">
                            {
                                totalAllocationError.length !== 0 &&
                                <div className='position-absolute d-flex align-items-center e-allocation-error'>
                                    <Icon icon="info-circle"
                                        size={16}
                                        className="me-1" />
                                    <p className='color-red margin-block-end-0 e-font-12 '>
                                        {totalAllocationError}
                                    </p>
                                </div>
                            }
                            {
                                nomineeDetail.length < 3 &&
                                <div className=" align-items-center gap-8px cursor-pointer d-lg-none d-md-none d-flex mb-lg-0 mb-md-0 mb-4"
                                    onClick={() => _validateForm(2)}>
                                    <Icon icon="add-circle1"
                                        size={24} />
                                    <p className="color-primary-color e-poppins-medium e-font-16 e-font-sm-16-14 line-height-16px mb-0">Add new nominee </p>
                                </div>
                            }
                            <GradientButton label="Add nominee and continue"
                                className="px-4 padding-12px-tb e-font-16 mob-w-100"
                                loading={apiLoader}
                                onPress={() => _validateForm(1)} />
                            {
                                nomineeDetail.length < 3 &&
                                <div className="align-items-center gap-8px cursor-pointer d-lg-flex d-md-block d-none"
                                    onClick={() => _validateForm(2)}>
                                    <Icon icon="add-circle1"
                                        size={24} />
                                    <p className="color-primary-color e-poppins-medium e-font-16 e-font-sm-16-14 line-height-16px mb-0">Add new nominee </p>
                                </div>
                            }
                        </div>
                    </Fragment>

                }


            </div>
            {
                showPinModal === true && (
                    <NomineeOTPVerification close={() => setShowPinModal(false)}
                        handleOTPSubmission={_submitNominee}
                        handleSuccess={_handleSuccess}
                        optInStatus={optInNominee}
                        nominee={processedNomineeData} />
                )
            }
        </div>

    )
}

export default NriNomineePage